(function () {
  'use strict';

  angular.module('ringbaPortal').component('filterSummary', {
    bindings: {
      criteria: '<',
      availableTags: '<',
      uploadedBulkTags: '<'
    },
    controller: FilterSummaryController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/filter-summary/filter-summary.view.html'
  });

  function FilterSummaryController(
    comparisonTypeService,
    tagService
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.isArray = angular.isArray;
    vm.getGeoValue = tagService.getGeoValue;
    vm.getBulkTagComparisonType = getBulkTagComparisonType;

    function onInit() {
    }

    function onChanges() {
      if (vm.criteria) {
        vm.criteriaCopy = angular.copy(vm.criteria);
        tagService.groupGeoTags(vm.criteriaCopy);
        comparisonTypeService.convertComparisonTypes(vm.criteriaCopy);

        if (vm.uploadedBulkTags) {
          _setBulkTagUploadName(vm.criteriaCopy, vm.uploadedBulkTags);
        }
      }
    }

    function getBulkTagComparisonType(isNegativeMatch) {
      return comparisonTypeService.getMultipleBulkTagComparisonSwitch(isNegativeMatch).value;
    }

    function _setBulkTagUploadName(criteria, bulkTagUploads) {
      _.forEach(criteria, function (andCriteria) {
        if (andCriteria.bulkCriteria) {
          const id = andCriteria.bulkCriteria.id || andCriteria.bulkCriteria.Id;
          const bulkTag = _.find(bulkTagUploads, { id: id });
          andCriteria.bulkCriteria.name = (bulkTag && bulkTag.name) || '';
        }
      });
    }

  }
})();
